import React from "react";
import "./Objective.scss";

import backgroundBg from "../../../assets/About/back-bg.png";
import objectiveImg from "../../../assets/About/objective-image.png";
import useAboutUs from "../../../hooks/useAboutUs";

const Objective = () => {
  const [aboutUs, setAboutUs] = useAboutUs();

  let objectiveData = aboutUs.filter(
    (obj) => obj.DescType === "OVERALL STRATEGIC OBJECTIVES"
  );

  return (
    <>
      <div className="objective">
        <div className="container-fluid p-0">
          <div
            className="back_bg"
            style={{ backgroundImage: `url(${backgroundBg})` }}
            data-aos="fade-down"
            data-aos-anchor-placement="top-center"
          ></div>
          <div className="heading_box">Objective</div>

          <div className="container">
            <div className="objective_content">
              <div className="row">
                <div className="col-lg-6 my-auto">
                  <div className="left">
                    <h4>{objectiveData[0]?.Title}</h4>
                  </div>
                </div>
                <div className="col-lg-6" data-aos="fade-left">
                  <img src={objectiveImg} className="img-fluid" alt="" />
                </div>
                <p>{objectiveData[0]?.Description}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Objective;
